import {
    CustomAccountSettingState,
    XcentiumAccountSettingsActions,
} from "@electricMotorShop/Store/Data/AccountSettings/AccountSettingsReducer";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getCurrentAccountState } from "@insite/client-framework/Store/Data/Accounts/AccountsSelector";
import {
    chain,
    DispatchSetInitialValues,
    FindDefaultBillTo,
} from "@insite/client-framework/Store/Pages/AccountSettings/Handlers/SetInitialValues";
import { DispatchProp } from "react-redux";

// XC Customization - Replacing DispatchSetInitialValues in the chain to call the new AccountSettingsReducer.

type CustomProps = DispatchProp<XcentiumAccountSettingsActions>;
type AccountSettingsProps = Parameters<typeof FindDefaultBillTo>[0];

function CustomDispatchSetInitialValues(props: AccountSettingsProps) {
    const account = getCurrentAccountState(props.getState() as CustomAccountSettingState).value;
    if (!account) {
        throw new Error(
            "There was no current account and we were trying to set initial values for the account settings page.",
        );
    }

    const customProps = props as CustomProps;

    customProps.dispatch({
        type: "Custom/AccountSettings/SetInitialValues",
        defaultBillToId: props.defaultBillTo?.id,
        defaultShipToId: props.defaultShipTo?.id,
        showSelectDefaultCustomer: props.showSelectDefaultCustomer,
        useDefaultCustomer: props.useDefaultCustomer,
        account,
    });
}

replaceInChain(chain, DispatchSetInitialValues, CustomDispatchSetInitialValues);
